<template>
  <div class="home">
    <!-- <vue-canvas-nest></vue-canvas-nest> -->
    <!-- 分类、banner -->
    <div>
      <div class="banner_content">
        <!-- <div class="fenlei_con">
					<div class="o_list">
						<p class="f20">{{$t("home.class.title")}}</p>
						<ul>
							<li :style="this.$i18n.locale == 'zh_CN' ? 'line-height:36px' : 'line-height:21px'">
								<router-link :to="{ path:'/biaodi',query:{ type:'二手设备' }}">{{$t("home.class.used_equipment")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'工程机械' }}">{{$t("home.class.construction_machinery")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'废旧金属' }}">
								{{$t("home.class.scrap_metal")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'废纸' }}">{{$t("home.class.waste_paper")}}</router-link>
							</li>
							<li :style="this.$i18n.locale == 'zh_CN' ? 'line-height:36px' : 'line-height:21px'">
						 <router-link :to="{ path:'/biaodi',query:{ type:'废贵金属' }}">
								{{$t("home.class.waste_precious_metal")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'包装' }}">{{$t("home.class.packing")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'印刷' }}">{{$t("home.class.printing")}}</router-link>/
							
								<router-link :to="{ path:'/biaodi',query:{ type:'化工危险废物' }}">{{$t("home.class.hazardous_chemical_waste")}}</router-link>
							</li>
							<li :style="this.$i18n.locale == 'zh_CN' ? 'line-height:36px' : 'line-height:21px'">
								<router-link :to="{ path:'/biaodi',query:{ type:'货存积压' }}">{{$t("home.class.overstock_of_goods")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'废电子电器' }}">{{$t("home.class.waste_electronic_appliances")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'手机' }}">{{$t("home.class.mobile_phone")}}</router-link>/
								
								<router-link :to="{ path:'/biaodi',query:{ type:'成型机' }}">{{$t("home.class.molding_machine")}}</router-link>
							</li>
							<li :style="this.$i18n.locale == 'zh_CN' ? 'line-height:36px' : 'line-height:21px'">
								<router-link :to="{ path:'/biaodi',query:{ type:'电池' }}">{{$t("home.class.battery")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'旧轮胎与橡胶' }}">{{$t("home.class.old_tires_and_rubber")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'鞋帽' }}">{{$t("home.class.shoes_and_Hats")}}</router-link>
								<router-link :to="{ path:'/biaodi',query:{ type:'服装' }}">{{$t("home.class.clothing")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'废玻璃' }}">{{$t("home.class.waste_glass")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'废旧木材' }}">{{$t("home.class.waste_wood")}}</router-link>/
								<router-link :to="{ path:'/biaodi',query:{ type:'库存旧衣服' }}">{{$t("home.class.stock_old_clothes")}}</router-link>/
							</li>
						
						</ul>
					</div>
					<div class="o_list">
						<p class="f20">合作伙伴</p>
						<ul>
							<li v-for="link in links">
								<p style="margin-bottom: -17px"><a :href="link.url" target="_blank" >{{link.title}}</a></p>
							</li>
						</ul>
					</div>
				</div> -->
        <div class="banner_con">
          <div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
              <div class="swiper-slide" :key="banner.id" v-for="banner in banners">
                <a :href="banner.url" style="display: block;">
                  <img :src="banner.img" style="width: 100%">
                </a>
              </div>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <!-- 移动端 -->
        <div class="banner_con mobile">
          <div v-swiper:mySwiperWap="swiperOptionWap">
            <div class="swiper-wrapper">
              <div class="swiper-slide" :key="banner.img" v-for="banner in banners">
                <a :href="banner.url" style="display: block;">
                  <img :src="banner.img">
                </a>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
      <JpPress></JpPress>
    </div>

    <div class="About">
      <div class="pub_title_box">
        <div class="f24">拍卖会</div>
        <div class="c_gray"><router-link :to="{ path:'/meetings'}">{{$t("home.more")}}</router-link></div>
      </div>
      <ul>
        <li v-for="(item,index) in meetings" :key="index">
          <router-link :to="{ path:'/biaodi',query:{ meeting_id:item.id,page:1,type:'全部' }}" class="List">
            <div class="Img" :style="{'backgroundImage':'url('+item.img+')'}"></div>
            <div class="Container">
              <h2>{{ item.title }}</h2>
              <p class="f16 meeting_text">拍卖企业：拍界官方</p>
              <p class="f16 meeting_text">开始时间：{{ item.start_at }}</p>
              <div>
                <router-link class="f16 meeting-btn" :to="{ path:'/biaodi',query:{ meeting_id:item.id,page:1,type:'全部' }}">标的目录</router-link>
                <router-link class="f16 meeting-btn" :to="{ path:'/biaodiDetails',query:{ id:item.first_subject_id,meeting_id:item.id}}">拍卖大厅</router-link>
              </div>
              <div class="People-lot">
                <p class="People-tab">围观次数：<span class="meetingcount">{{item.view_count*1+item.view_base_count*1}}</span>次</p>
                <p class="People-tab">标的数量：<span class="lotNum">{{item.subject_count}}</span>个</p>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- 拍卖专场 -->
    <div class="cszc_temp">
      <div class="pub_title_box">
        <div class="f24 left-vertical">标的展示</div>
        <div class="c_gray">
          <router-link to="/biaodi?type=全部&page=1">{{$t("home.more")}}</router-link>
        </div>
      </div>
      <div class="pp_list">
        <div class="l_box" v-for="(item,index) in subjectsArr1" :key="index">
          <router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
            <div style="position: relative;" class="img_box" :style="{'backgroundImage':'url('+item.img+')'}">
              <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
            </div>
            <div class="ms_box">
              <div class="ms_top">
                <h2 class="f20">{{ item.title }}</h2>
                <p class="c_gray">{{$t("home.big_title.special_auction.auction_platform")}}拍界</p>
                <div class="s_price">
                  <p class="f16">{{$t("home.big_title.special_auction.current_price")}}</p>
                  <p class="f30 fw c_red"><span class="f20">￥</span>{{ item.price/10000 }}万元<span class="new-unit2" v-if="item.new_unit">/{{item.new_unit}}</span></p>
                </div>
              </div>
              <div class="ms_bottom">
                <p>{{$t("home.big_title.special_auction.opening_time")}}{{ item.start_at }}</p>
                <p>{{$t("home.big_title.special_auction.subject_address")}}{{ item.city }}</p>
              </div>
            </div>
          </router-link>
        </div>
        <div class="r_box">
          <div class="o_temp" v-for="(item,index) in subjectsArr234" :key="index+1">
            <router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
              <div style="position: relative;" class="img_con" :style="{'backgroundImage':'url('+item.img+')'}">
                <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
              </div>
              <p class="name">{{ item.title }}</p>
              <p class="price">￥{{ item.price/10000 }}万元</p>
            </router-link>
          </div>
        </div>
      </div>
      <!-- <div class="pp_list">
				<div class="l_box" v-for="(item,index) in subjectsArr5" :key="index+2">
					<router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
						<div class="img_box" :style="{'backgroundImage':'url('+item.img+')'}"></div>
						<div class="ms_box">
							<div class="ms_top">
								<h2 class="f20">{{ item.title }}</h2>
								<p class="c_gray">拍卖平台：拍界</p>
								<div class="s_price">
									<p class="f16">当前价位</p>
									<p class="f30 fw c_red"><span class="f20">￥</span>{{ Math.trunc(item.price) }}</p>
								</div>
							</div>
							<div class="ms_bottom">
								<p>开拍时间：{{ item.start_at }}</p>
								<p>标的所在：{{ item.city }}</p>
							</div>
						</div>
					</router-link>
				</div>
				<div class="r_box">
					<div class="o_temp" v-for="(item,index) in subjectsArr678" :key="index+3">
						<router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
							<div class="img_con" :style="{'backgroundImage':'url('+item.img+')'}"></div>
							<p class="name">{{ item.title }}</p>
							<p class="price">￥{{ Math.trunc(item.price) }}</p>
						</router-link>
					</div>
				</div>
			</div>
			<div class="pp_list">
				<div class="l_box" v-for="(item,index) in subjectsArr9" :key="index+4">
					<router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
						<div class="img_box" :style="{'backgroundImage':'url('+item.img+')'}"></div>
						<div class="ms_box">
							<div class="ms_top">
								<h2 class="f20">{{ item.title }}</h2>
								<p class="c_gray">拍卖平台：拍界</p>
								<div class="s_price">
									<p class="f16">当前价位</p>
									<p class="f30 fw c_red"><span class="f20">￥</span>{{ Math.trunc(item.price) }}</p>
								</div>
							</div>
							<div class="ms_bottom">
								<p>开拍时间：{{ item.start_at }}</p>
								<p>标的所在：{{ item.city }}</p>
							</div>
						</div>
					</router-link>
				</div>
				<div class="r_box">
					<div class="o_temp" v-for="(item,index) in subjectsArr101112" :key="index+5">
						<router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
							<div class="img_con" :style="{'backgroundImage':'url('+item.img+')'}"></div>
							<p class="name">{{ item.title }}</p>
							<p class="price">￥{{ Math.trunc(item.price) }}</p>
						</router-link>
					</div>
				</div>
			</div> -->
      <!-- 移动端 -->
      <div class="pp_list mobile">
        <div class="l_box" v-for="(item) in subjectsArrM6" :key="item.id">
          <router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
            <div class="img_box" :style="{'backgroundImage':'url('+item.img+')'}"></div>
            <div class="ms_box">
              <div class="ms_top">
                <h2 class="f20">{{ item.title }}</h2>
                <!-- <p class="c_gray">{{$t("home.big_title.special_auction.auction_platform")}}拍界</p> -->
                <p class="c_gray">编号：[{{item.id}}]</p>
                <div class="s_price">
                  <p class="f16">起拍价</p>
                  <p><span class="f24 c_red">{{ Math.trunc(item.price) }}</span>元<span v-if="item.new_unit">/{{item.new_unit}}</span></p>
                </div>
              </div>
              <div class="ms_bottom">
                <p>{{$t("home.big_title.special_auction.opening_time")}}<br />{{ item.start_at }}</p>
                <p>{{$t("home.big_title.special_auction.subject_address")}}{{ item.city }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- 拍卖企业 -->
    <!-- <div class="pmqy_temp">
			<div class="pub_title_box">
				<div class="f24">{{$t("home.big_title.enterprise.title")}}</div>
				<div class="c_gray"><router-link to="/paimaiqiye">{{$t("home.more")}}</router-link></div>
			</div>
			<ul>
				<li v-for="(item,index) in subjectsArrQy" :key="index">
					<router-link :to="{ path:'/qiyeDetails',query:{ id:item.id }}" class="home_qiye">
						<div class="qiye_img" :style="{'backgroundImage':'url('+item.img+')'}"></div>
						<div>
							<div>{{ item.title }}</div>
							<div class="qiye_bottom">{{$t("home.big_title.enterprise.entry_time")}}{{ item.created_at }}</div>
						</div>
					</router-link>
				</li>
			</ul>
		</div> -->
    <!-- 近期预告 -->
    <div class="jqyg_temp">
      <div class="pub_title_box">
        <div class="f24 left-vertical">标的预展</div>
        <!-- <div class="f24">{{$t("home.big_title.recent_notice")}}</div> -->
        <div class="c_gray">
          <router-link :to="{ path:'/biaodi',query:{ type:'全部',page:'1' }}">{{$t("home.more")}}</router-link>
        </div>
      </div>
      <ul>
        <li v-for="(item,index) in subjectsArrF8" :key="index+6" style="position:relative;">
          <router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
            <img class="push_img" src="@/assets/images/push.png" v-if="item.label == 'push'">
            <img class="hot_img" src="@/assets/images/hot.png" v-if="item.label == 'hot'">
            <img class="hot_img" src="@/assets/images/fire.png" v-if="item.label == 'fire'">
            <img class="hot_img" src="@/assets/images/like.png" v-if="item.label == 'like'">
            <div style="position: relative;" class="img_con" :style="{'backgroundImage':'url('+item.img+')'}">
              <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
            </div>
            <div class="text_box">
              <p class="f16">{{ item.title }}</p>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.starting_price")}}</p>
                <p><span class="c_red f24">{{ Math.trunc(item.start_price) }}</span>元<span v-if="item.new_unit">/{{item.new_unit}}</span></p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.number")}}</p>
                <p>[{{ item.id }}]</p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.auction_time")}}</p>
                <p>{{ item.start_at }}</p>
              </div>
              <div class="cj_price c_gray">
                <p>{{$t("subject.list.subject_address")}}</p>
                <p>{{item.city}}</p>
              </div>
              <div class="cj_price c_gray see_person">
                <!-- <img src="@/assets/images/see1.png" alt="">{{Number(item.sign_count) + Number(item.sign_base_count)}}{{$t("subject.list.sign_up")}} |  -->
                <img src="@/assets/images/see2.png" alt="">{{Number(item.view_count) + Number(item.view_base_count)}}{{$t("subject.list.onlookers")}}
              </div>
            </div>
            <div class="wkp">{{item.biaodiState}}</div>

          </router-link>
        </li>
      </ul>
    </div>
    <!-- 成交案例 -->
    <div class="cjal_temp" v-if="customerDatas.enterprise_status==1">
      <div class="pub_title_box">
        <div class="f24 left-vertical">{{$t("home.big_title.closing_case.title")}}</div>
        <!-- <div class="f24">成交总金额：{{Math.round(total/10000 * 10) / 10}}万元</div> -->
        <div class="c_gray">
          <router-link :to="{ path:'/biaodi',query:{ status:'3',type:'全部',page:'1' }}">{{$t("home.more")}}</router-link>
        </div>
      </div>
      <ul>
        <li v-for="(item,index) in successSubjects" :key="index+7">
          <router-link :to="{ path:'/biaodiDetails',query:{ id:item.id }}">
            <div style="position: relative;" class="img_box" :style="{'backgroundImage':'url('+item.img+')'}">
              <p class="watermark"><img src="@/assets/images/waterMark300.png"></p>
            </div>
            <div class="text_box">
              <p class="f16">{{ item.title }}</p>
              <div class="cj_price">
                <p class="c_gray">{{$t("home.big_title.closing_case.transaction_price")}} </p>
                <p class="f30 c_red">{{ (item.price / 10000).toFixed(6).replace(/\.?0+$/, '') }}<span class="f24">万元</span><span class="new-unit" v-if="item.new_unit">/{{item.new_unit}}</span></p>
              </div>
              <div class="cj_time">
                <span class="c_gray">{{$t("home.big_title.closing_case.closing_time")}} </span>
                <span class="f16 fw">{{ item.end_at }}</span>
              </div>
            </div>
            <img class="chengjiao_img" src="../assets/images/chengjiao.png">
          </router-link>
        </li>
      </ul>
    </div>
  </div>

</template>

<script>
const wx = require('weixin-js-sdk');
import JpPress from '@/components/JpPress.vue';

export default {

  metaInfo: {
    title: "拍界——唤醒您的沉睡资产",
    meta: [{
      name: "keywords",
      content: "拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }, {
      name: "description",
      content: "拍界是一个专注拍卖的网络平台，拍卖无边界，拍卖更便捷。拍界，拍界官网，捡漏，拍卖，手机拍卖，二手设备拍卖，废旧物资拍卖，整厂拍卖，房屋拍卖，车辆拍卖，土地拍卖，小商品拍卖"
    }]
  },
  data () {
    return {
      banners: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 3000,                      // 几秒播放一次
          disableOnInteraction: false       // 手动滑动后是否停止自动播放
        },
        width: 1200,
        loop: true,
        speed: 300
      },
      swiperOptionWap: {
        pagination: {
          el: '.swiper-pagination'
        },
        autoplay: {
          delay: 3000,                      // 几秒播放一次
          disableOnInteraction: false       // 手动滑动后是否停止自动播放
        },
        loop: true,
        height: 300,
        speed: 300
      },
      subjectsArrF8: [],
      subjectsArr: [],
      subjectsArrM6: [],
      subjectsArr1: [],
      subjectsArr234: [],
      subjectsArr5: [],
      subjectsArr678: [],
      subjectsArr9: [],
      subjectsArr101112: [],
      successSubjects: [],

      //拍卖企业
      subjectsArrQy: [],
      total: 0,
      meetings: [],
      links: [],
      currentStep: 1,
      customerDatas: [],
      token: localStorage.getItem('apiToken'),
    }
  },
  created () {
    // 显示公共栏
    this.$emit('header', true);
    this.$emit('footer', true);
    // 拍卖专场 请求页面数据
    var order = "id DESC";
    this.axios.get(this.$global.apiUrl.subjects, {
      // params: {
      // 	page: 1,
      // 	limit: 12,
      // 	order: order
      // }
      params: {
        page: 1,
        limit: 6,
        status: 1,
        order: 'start_at'
      }
    })
      .then((response) => {
        if (response.data.error.code == 0) {
          this.subjectsArr = response.data.subjects;
          this.subjectsArrM6 = response.data.subjects.slice(0, 6);
          this.subjectsArr1 = response.data.subjects.slice(0, 1);
          this.subjectsArr234 = response.data.subjects.slice(1, 4);
          // this.subjectsArr5 = response.data.subjects.slice(4,5);
          // this.subjectsArr678 = response.data.subjects.slice(5,8);
          // this.subjectsArr9 = response.data.subjects.slice(8,9);
          // this.subjectsArr101112 = response.data.subjects.slice(9,12);
        }
      })
      .catch(() => { });
    // 获取banners
    this.axios.get(this.$global.apiUrl.banners + "?type=subject")
      .then((response) => {
        if (response.data.error.code == 0) {
          this.banners = response.data.banners;
          //console.log(this.banners);
        }
      })
      .catch(() => { });

    this.axios.get("https://api.paijie.com/links")
      .then((response) => {
        if (response.data.error.code == 0) {
          this.links = response.data.links;
        }
      })
      .catch(() => { });


    var order2 = "end_at DESC";
    // 成交标的
    this.axios.get(this.$global.apiUrl.subjects, {
      params: {
        page: 1,
        limit: 4,
        status: 3,
        order: order2
      }
    })
      .then((response) => {
        if (response.data.error.code == 0) {
          this.successSubjects = response.data.subjects;
        }
      })
      .catch(() => { })
    // this.axios.get(this.$global.apiUrl.subjects_successTotal)
    //   .then((response) => {
    //     if (response.data.error.code == 0) {
    //       this.total = response.data.total;
    //     }
    //   })
    //   .catch(() => { })

    // 拍卖企业
    // this.axios.get(this.$global.apiUrl.enterprises)
    //   .then((response) => {
    //     if (response.data.error.code == 0) {
    //       this.subjectsArrQy = response.data.enterprises;
    //     }

    //   })
    //   .catch(() => { })

    // 近期预告
    this.axios.get(this.$global.apiUrl.subjects, {
      // params: {
      // 	page: 1,
      // 	limit: 8,
      // 	status: 1,
      // 	order: 'start_at'
      // }
      params: {
        page: 1,
        limit: 8,
        order: order
      }
    })
      .then((response) => {
        if (response.data.error.code == 0) {
          this.subjectsArrF8 = this.computedStatus(response.data.subjects);
        }

      })

    // 获取拍卖会列表
    this.axios.get('https://api.paijie.com/meetings?limit=3')
      .then((response) => {
        if (response.data.error.code == 0) {
          this.meetings = response.data.meetings;
          // console.log(this.meetings );
        }
      })
      .catch(() => {
        // console.log(response.data.error.message)
      })

      .catch(() => { })



    document.onselectstart = new Function("event.returnValue=false;");
    document.oncontextmenu = new Function("event.returnValue=false;");

    // 页面至顶部
    window.scrollTo(0, 0);

    // 微信分享
    const url = window.location.href.split('#')[0] //向服务端提供授权url参数，并且不需要#后面的部分
    this.axios.get(this.$global.apiUrl.wxuser_signature, {
      params: {
        url: url
      }
    })
      .then((response) => {
        if (response.data.error.code == 0) {
          wx.config({
            debug: false, // 开启调试模式,
            appId: response.data.signPackage.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
            timestamp: response.data.signPackage.timestamp, // 必填，生成签名的时间戳
            nonceStr: response.data.signPackage.nonceStr, // 必填，生成签名的随机串
            signature: response.data.signPackage.signature, // 必填，签名，见附录1
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
        }
      })
    let _this = this;
    // setInterval(function () {
    //   _this.currentStep++;
    //   if (_this.currentStep > 6) _this.currentStep = 1
    // }, 1500)

    // 请求个人资料数据
    this.axios.get(this.$global.apiUrl.customer, {
      params: {
        apiToken: this.token
      }
    })
      .then((response) => {
        if (response.data.error.code == 0) {
          this.customerDatas = response.data.customer;
        }
      })

  },
  methods: {
    // 计算标的状态
    computedStatus: function (subjects) {
      // console.log(0.1+0.2)
      let _this = this;
      subjects.forEach(function (value, index, array) {
        // console.log(subjects);
        // console.log(value);
        // console.log(index);
        // console.log(array);
        // 距离开始的时间
        var startTime = parseInt((new Date(value.start_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));
        // 距离结束的时间
        var endTime = parseInt((new Date(value.end_at.replace(/\-/g, '/')).getTime() - new Date().getTime()));

        if (startTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_1")
        }
        if (startTime <= 0 & endTime > 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_2")
        }
        if (startTime < 0 & endTime <= 0) {
          array[index]['biaodiState'] = _this.$t("subject.list.state.s_3")

        }


      });
      // console.log(subjects)
      return subjects;
    },
  },
  mounted () {
    // 微信分享
    wx.ready(() => {
      // 分享朋友
      wx.updateAppMessageShareData({
        title: '拍界',
        desc: '拍界经典新时代,拍卖无边界,拍卖更便捷',
        link: window.location.href,
        imgUrl: 'https://paijie.com/WechatIMG66.png',
        success: () => { }
      })
      // 分享朋友圈
      wx.updateTimelineShareData({
        title: '拍卖无边界,拍卖更便捷,拍界经典新时代',
        link: window.location.href,
        imgUrl: 'https://paijie.com/WechatIMG66.png',
        success: () => { }
      })
    })
    // console.log('Current Swiper instance object', this.mySwiper);
  },
  computed: {

  },
  components: {
    JpPress,
  }
  // components: { vueCanvasNest }

}
</script>
<style scoped>
.left-vertical {
  border-left: 3px solid #c71622;
  padding-left: 20px;
}
.new-unit {
  font-size: 14px;
  color: #888;
}
.new-unit2 {
  font-size: 16px;
  color: #000;
  font-weight: normal;
}
</style>